var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"notes"},[_c('input',{attrs:{"type":"text","placeholder":_vm.dataPlaceholder},domProps:{"value":_vm.dataNote},on:{"change":function($event){return _vm.changeNote($event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }